.groupContainer {
  display: flex;
  flex-direction: column;
  height: calc(100% - 144px);
  width: 100%;
  overflow: scroll;
}
